import * as React from 'react';
import Creatable from 'react-select/lib/Creatable';
import { Translate } from '../../../shared/LanguageService';
import { ISelect } from './Entities';

interface IProps {
    value: ISelect;
    options: ISelect[];
    onChange: (e: any) => void;
}

const StoreySelect = (props: IProps) => {
    return (
        <Creatable
            value={{
                value: props.value.id,
                label: props.value.name ? props.value.name : Translate(props.options[0].name)
            }}
            promptTextCreator={(label: string) =>
                Translate('order/plan/storey/select/create-text', {
                    label: label
                })
            }
            placeholder={Translate('order/plan/storey/select/placeholder')}
            options={props.options.map((p: ISelect) => ({
                value: p.id,
                label: p.id > -1 ? Translate(p.name) : p.name
            }))}
            onChange={props.onChange}
            clearable={false}
            backspaceRemoves={false}
        />
    );
};

export default StoreySelect;
